import React from "react";
import { Button, MenuSection } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import { PublisherPrefixStatusEnum } from "../../types/Api";
export var buildPublisherPrefixActionMenu = function (publisherPrefix, canEditPublisherPrefix, onEdit, canShowDeclareAction, declareAction) {
    if (canShowDeclareAction === void 0) { canShowDeclareAction = false; }
    if (declareAction === void 0) { declareAction = null; }
    var canEdit = canEditPublisherPrefix &&
        publisherPrefix.status === PublisherPrefixStatusEnum.ACTIVE;
    if (!canEdit && !canShowDeclareAction) {
        return undefined;
    }
    return function () { return (React.createElement(MenuSection, { label: "Akce", id: "actions-menu" },
        canEdit && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: onEdit, fullWidth: true },
            React.createElement(FormattedMessage, { id: "ui-br-agency.button.edit" }))),
        declareAction)); };
};
